import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(3.375),
  paddingBottom: theme.spacing(5.125),
  [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(2.75),
  },
  '& .MTVTitle': {
    color: theme.palette.grey[700],
    lineHeight: theme.spacing(5),
    marginBottom: theme.spacing(2),
  },
}));

export default StyledContainer;
